import {
    GET_LIST_CUSTOMER_SOURCE,
    GET_SPECIFIC_CUSTOMER_SOURCE,
    UPDATE_SPECIFIC_CUSTOMER_SOURCE,
    CREATE_NEW_CUSTOMER_SOURCE,
    REMOVE_CUSTOMER_SOURCE,
    GET_CUSTOMER_SOURCE_ACTIVE
} from '@/redux/actions/types';

/**
 * initial state
 */
const INIT_STATE = {
    customerSourceList: [],
    currentCustomerSource: null,
    customerSourceActiveList: [],
    pagination: {
        currentPage: 1,
        total: 0, // total records
        perPage: 50
    }
};

export default (state = INIT_STATE, action) => {
    switch (action.type) {
        case GET_LIST_CUSTOMER_SOURCE: {
            return {
                ...state,
                customerSourceList: action.payload?.data || [],
                pagination: {
                    currentPage: parseInt(action.payload.current_page),
                    total: parseInt(action.payload.total),
                    perPage: parseInt(action.payload.per_page),
                }
            }
        }
        case GET_CUSTOMER_SOURCE_ACTIVE: {
            return {
                ...state,
                customerSourceActiveList: action.payload.data,
            }
        }
        case GET_SPECIFIC_CUSTOMER_SOURCE: {
            return { ...state, currentCustomerSource: action.payload }
        }
        case CREATE_NEW_CUSTOMER_SOURCE: {
            return {
                ...state,
                customerSourceList: [action.payload, ...state.customerSourceList],
                customerSourceActiveList: [action.payload, ...state.customerSourceActiveList],
                total: state.total + 1
            }
        }
        case UPDATE_SPECIFIC_CUSTOMER_SOURCE: {
            let index = state.customerSourceList.findIndex((item) => {
                return item.id == action.payload.id;
            });
            let temp = [...state.customerSourceList];
            temp[index] = action.payload;
            //
            let index2 = state.customerSourceActiveList.findIndex((item) => {
                return item.id == action.payload.id;
            });
            let temp2 = [...state.customerSourceActiveList];
            temp[index2] = action.payload;

            return { ...state, customerSourceList: temp, customerSourceActiveList: temp2 }
        }
        case REMOVE_CUSTOMER_SOURCE: {
            let temp = state.customerSourceList.filter(item => {
                return action.payload.indexOf(item.id) < 0;
            });

            let temp2 = state.customerSourceActiveList.filter(item => {
                return action.payload.indexOf(item.id) < 0;
            });
            return { ...state, customerSourceList: temp, customerSourceActiveList: temp2 }
        }
        default: return { ...state };
    }
}
